import {
  Box,
  styled,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  Typography,
} from "@mui/material"
import { colors } from "../../theme/colors"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const ToggleGroupContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
})

export const ToggleGroup = styled(ToggleButtonGroup)({
  background: "transparent",
  borderRadius: 0,
  "& .Mui-selected": {
    backgroundColor: `${colors.lightBlack} !important`,
    color: `${colors.white} !important`,
    "&:hover": {
      backgroundColor: `${colors.lightBlack} !important`,
      color: colors.white,
    },
  },
})

export const Toggle = styled(ToggleButton)({
  border: "none",
  background: "transparent",
  color: colors.lightBlack,
  borderRadius: "10px !important",
  padding: "6px 16px",
  fontSize: 14,
  lineHeight: 1.45,
  "& .Mui-selected": {
    color: colors.white,
  },
})

export const MonthContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: 20,
  marginBottom: 30,
})

export const MonthDropdownContainer = styled(Box)({
  display: "flex",
  alignItems: "baseline",
  gap: 6,
})

export const MonthText = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 22,
  lineHeight: 1,
  fontWeight: "bold",
})

export const MonthDropdownButton = styled(Box)({
  color: colors.blue,
  background: "transparent",
  fontSize: 22,
  fontWeight: "bold",
  lineHeight: 1,
  padding: 0,
})

export const UploadHistoryButton = styled(Button)({
  color: colors.darkGrey,
  background: "transparent",
  fontSize: 13,
})

export const DatesHistory = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 30,
})

export const DateHistory = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 20,
})

export const TransactionDate = styled(Typography)({
  color: colors.darkGrey,
  fontSize: 14,
  textTransform: "uppercase",
  fontWeight: "bolder",
})
